export const CLIENT_KYC_CONFIRMATION = 'topup_digital_kyc_confirmation'; // set this to Confirmed/Unconfirmed
export const KYC_STATUS_SUBMITTED = 'submitted';
export const KYC_STATUS_REJECTED = 'rejected';
export const KYC_STATUS_VERIFIED = 'verified';
export const CLIENT_KYC_CONFIRMED = 'confirmed';
export const CLIENT_KYC_UNCONFIRMED = 'unconfirmed';
